// src/styles/commonStyles.js

const commonStyles = {
    buttonPrimary: {
      padding: "10px 16px",
      border: "none",
      borderRadius: "6px",
      background: "#007bff",
      color: "white",
      cursor: "pointer",
      fontWeight: "bold",
    },
  
    buttonSecondary: {
      padding: "10px 16px",
      border: "none",
      borderRadius: "6px",
      background: "#6c757d",
      color: "white",
      cursor: "pointer",
    },
  
    card: {
      background: "white",
      padding: "20px",
      borderRadius: "12px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    },
  
    input: {
      padding: "10px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      width: "100%",
      marginBottom: "10px",
    },
  };
  
  export default commonStyles;